import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import homeHero from "../../Assets/homehero-square.webp";
import "./HomeHero.scss";

function HomeHero() {
  return (
    <section className="hp-hero" aria-labelledby="home-heading">
      <div className="hp-container">
        <div className="hp-hero-grid">
          <div className="hp-hero-copy">
            <span className="hp-eyebrow"><span className="hp-status-dot" /> YOUR LAUNDRY SHEETS. YOUR BRAND.</span>
            <h1 id="home-heading">Private Label<br />Laundry Detergent Sheets<br /><span>Manufacturer</span></h1>
            <p>We manufacture private label laundry sheets with custom formulas, scents and packaging. Expand into tablets, pods and more.</p>
            <div className="hp-actions">
              <Link className="hp-button" to="/products">Explore Products <FiArrowRight aria-hidden="true" /></Link>
              <Link className="hp-text-link" to="/contact">Start Your Project</Link>
            </div>
            <span className="hp-hero-note">For retail, e-commerce &amp; refill brands</span>
          </div>
          <Link to="/products" className="hp-hero-visual" aria-label="Explore laundry detergent sheets and Klean Leaf’s wider product range">
            <img src={homeHero} alt="Klean Leaf private label laundry detergent sheets with laundry pods and household cleaning products on a countertop" width={1600} height={1600} decoding="async" />
            <span className="hp-hero-caption"><span>Start with sheets. Explore the range.</span></span>
          </Link>
        </div>
        <div className="hp-proof-strip" aria-label="Klean Leaf at a glance">
          <span><strong>300+</strong> Clients</span>
          <span><strong>12+</strong> Years of experience</span>
          <span><strong>Ohio, USA</strong> Sample support</span>
          <span><strong>Worldwide</strong> Shipping coordination</span>
        </div>
      </div>
    </section>
  );
}

export default HomeHero;
